import { MediaDownloadDto } from 'collaboration-service';
import { getColor, getUriFromLinkByName, Icon, styled } from 'imaginarity-react-ui';
import * as _ from "lodash";
import Carousel from 'nuka-carousel';
import * as React from 'react';
import { useThemePart } from 'services/useAppTheme';
import { CMSSC as T } from './CMSSC';
interface CMSPreviewProps {
    name: string;
    media?: MediaDownloadDto;
}
const Empty = () => {
    const src = useThemePart(x => x.missingPreviewImageLink);
    return <T.PreImage src={src} />;
};

const HDiv = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${p => getColor(p, "background")};
`;


const CMSPreview = (p: CMSPreviewProps) => {
    const { media, name } = p;

    const url = getUriFromLinkByName(media) ?? getUriFromLinkByName(media, 'download');

    const thumbs = (media?.thumbnails ?? []).length > 0 ? media?.thumbnails : undefined;
    const renderContent = React.useMemo(() => () => {
        const s = 1.0;
        if (!media)
            return Empty();
        const mt = media.mediaType;
        if (thumbs && thumbs[0]?.mediaType === "text/html") {
            return <HDiv><iframe
                src={thumbs![0].links[0].uri}
                title="preview"
                style={{ width: `${100 / s}%`, height: `${100 / s}%`, transform: `scale(${s})`, transformOrigin: "top left" }}
            />
            </HDiv>
        }
        else if (mt && mt.startsWith("image")) {
            return <T.PreImage src={url} />;
        }
        else if (mt && mt.startsWith("video") && mt !== "video/x-ms-wmv" && mt !== "video/mpeg") {
            return <T.PreVideo src={url} controls />;
        }
        // else if (mt && (mt === "application/pdf" || mt === "application/x-pdf") && url) {
        //     //return <T.PrePdf data={url} type="application/pdf" />;
        //     return <PDF url={url} />
        // }
        else if (mt && (mt === "application/pdf" || mt === "application/x-pdf")) {
            return <T.PrePdf data={url} type="application/pdf" key={url} />;
        }
        else if (thumbs) {
            return (
                <T.Slider>
                    <Carousel
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "80%",
                            height: "auto",
                            pointerEvents: thumbs.length === 1 ? "none" : undefined
                        }}
                        slidesToShow={1}
                        cellAlign="left"
                        cellSpacing={40}
                        pauseOnHover
                        autoplayInterval={10000}
                        autoGenerateStyleTag
                        withoutControls={thumbs.length === 1}
                        dragging={true}
                        swiping={thumbs.length > 1}
                        autoplay={thumbs.length > 1}
                        wrapAround={thumbs.length > 1}
                        renderCenterLeftControls={({ previousSlide }) => (
                            <div onClick={previousSlide} className="slider-control-left">
                                <Icon name="chevron left" size="5em" />
                            </div>
                        )}
                        renderCenterRightControls={({ nextSlide }) => (
                            <div onClick={nextSlide} className="slider-control-right">
                                <Icon name="chevron right" size="5em" />
                            </div>
                        )}
                    >
                        {_.map(thumbs, (t, i) => (
                            <T.PreImage src={getUriFromLinkByName(t)} alt="preview" key={i} />
                        ))}
                    </Carousel>
                </T.Slider>
            );
        }
        return Empty();
    }, [media, thumbs, url]);
    const isPdf = p.media && (p.media?.mediaType === "application/pdf" || p.media?.mediaType === "application/x-pdf");
    return (
        <>
            <T.PreContainer isPdf={isPdf}>
                {renderContent()}
            </T.PreContainer>
            {!isPdf &&
                <T.PreFooter>{name}</T.PreFooter>
            }
        </>
    );
}
export default CMSPreview;